import { STEPS, StepKey } from "./types";

export function StepIndicator({ current }: { current: StepKey }) {
  const idx = STEPS.findIndex((s) => s.key === current);
  return (
    <div className="wizard-steps" aria-label="Progress">
      {STEPS.map((s, i) => (
        <div
          key={s.key}
          className={
            "wizard-step-dot" +
            (i === idx ? " is-current" : "") +
            (i < idx ? " is-done" : "")
          }
        >
          <span className="wizard-step-num">{i + 1}</span>
        </div>
      ))}
    </div>
  );
}
